// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"fdcbc8c3","378":"704b8534","781":"fdcbc8c3","904":"ea0e6b15"}[chunkId] + ".chunk.css";
};